import React from 'react'
import { Paper, Button } from '@material-ui/core'

import { EnterpriseContainer } from 'components'
import useInitiativeContainer from './Style'
import { IInitiativeSubmissionContainerProps } from './Interfaces'
import { ConfirmAction } from 'smart-components'

const InitiativeSubmissionContainer: React.FC<IInitiativeSubmissionContainerProps> = ({
  title,
  submissionPageCopyText,
  questions,
  hasGpaQuestions,
  gpaQuestions,
  bottomBar,
  hasWithdrawButton,
  withdrawConfirmationMessage,
  onWithdrawButtonClick,
  withdrawButtonText
}) => {
  const classes = useInitiativeContainer({})
  return (
    <EnterpriseContainer hasBottomBar={true}>
      {hasWithdrawButton && (
        <div className={classes.withdrawButtonContainer}>
          <ConfirmAction
            id="initiave-submission-action"
            title="Confirm action"
            content={withdrawConfirmationMessage}
            onConfirm={onWithdrawButtonClick}
          >
            {(isOpen, toggleDialog) => (
              <Button
                id="initiave-submission-withdraw-button"
                variant="contained"
                className={classes.withdrawButton}
                onClick={toggleDialog}
                disabled={isOpen}
              >
                {withdrawButtonText}
              </Button>
            )}
          </ConfirmAction>
        </div>
      )}
      <Paper className={classes.paper}>
        <div className={classes.titleContainer}>
          <h1 id="initiave-submission-title" className={classes.titleText}>
            {title}
          </h1>
        </div>
        <div>
          <h3 id="initiave-submission-sub-title" className={classes.subtitle}>
            {submissionPageCopyText}
          </h3>
        </div>
        <div className={classes.questionsContainer}>{questions}</div>
        {hasGpaQuestions && <div className={classes.gpaContainer}>{gpaQuestions}</div>}
      </Paper>
      {bottomBar}
    </EnterpriseContainer>
  )
}

export default InitiativeSubmissionContainer
